<div *ngIf="!p.renderMobile">
  <ion-row class="content">
    <ion-col size="2">
      {{ row.bookingSpaces[0].space.floor.building.name }}
    </ion-col>
    <ion-col size="2">
      {{ row.bookingSpaces[0].space.floor.name }}
    </ion-col>
    <ion-col size="2">
      {{ row.bookingSpaces[0].space.name }}
      <img
        *ngIf="row.bookingSpaces[0].space.subType"
        [src]="spaceService.searchSubtypeIcon(row.bookingSpaces[0].space.subType)"
        class="light"
      />
    </ion-col>
    <ion-col size="3">
      {{ row.startTime | dateSti }}
    </ion-col>
    <ion-col size="3">
      {{ row.endTime | dateSti }}
    </ion-col>
    <ion-col size="2">
      <ng-container *ngIf="row.userOwner">
        {{
          row.bookingSpaces[0].number
            ? row.bookingSpaces[0].number
            : row.userOwner.carPlate
        }}
      </ng-container>
    </ion-col>
    <ion-col size="2">
      <ng-container *ngIf="row.description">
        {{ row.description }} <strong>({{ "SPACE.GUEST" | translate }})</strong>
      </ng-container>
      <ng-container *ngIf="!row.description">
        {{ row.userOwner.firstName }} {{ row.userOwner.lastName }}
        <strong *ngIf="row.userOwner"
          >({{ companyServ.getCompanyName(row.userOwner.idCompany) }})</strong
        >
      </ng-container>
    </ion-col>
    <ion-col size="2">
      {{ "ADMIN.PARKING.CATEGORY." + row.status.toUpperCase() | translate }}
    </ion-col>
  </ion-row>
</div>

<ion-card *ngIf="p.renderMobile" class="content-card-noborder">
  <ion-card-content class="parking__status">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col>
          {{ "ADMIN.PARKING.CATEGORY." + row.status.toUpperCase() | translate }}
          <div class="line-divider"></div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
  
  <ion-card-header>
    <div>
      <ion-card-title>
        {{ "SPACE.PLACE" | translate }}
        {{ row.bookingSpaces[0].space.name }}
        <img
          class="space-booking-view__mobile-icon light"
          *ngIf="row.bookingSpaces[0].space.subType"
          [src]="
            spaceService.searchSubtypeIcon(row.bookingSpaces[0].space.subType)
          "
        />
      </ion-card-title>
      <ion-card-subtitle>
        <ion-icon src="../../../assets/icons/building-alt.svg"></ion-icon>
        {{ row.bookingSpaces[0].space.floor.building.name }}
        <ion-icon name="layers-outline" class="margin-left-8 light"></ion-icon>
        {{ row.bookingSpaces[0].space.floor.name }}
      </ion-card-subtitle>
    </div>
  </ion-card-header>

  <ion-card-content class="space-booking-view__mobile-content">
    <ion-grid class="no-padding-grid booking-mobile">

      <ng-container *ngIf="row.userOwner">
        <ion-row class="margin-bottom-8">
            <ion-icon name="person-outline" class="margin-right-8"></ion-icon>
            {{ row.userOwner.firstName }} {{ row.userOwner.lastName }}
          <strong *ngIf="row.userOwner"
            >({{ companyServ.getCompanyName(row.userOwner.idCompany) }})</strong
          >
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-icon src="../../../assets/icons/car.svg" class="margin-right-8"></ion-icon>
            {{
              row.bookingSpaces[0].number
                ? row.bookingSpaces[0].number
                : row.userOwner.carPlate
            }}
          </ion-col>
        </ion-row>
      </ng-container>
      
      <ng-container *ngIf="row.description && (row.owner=='guest')">
        <ion-row>
          <ion-col class="space-booking-view__mobile-barrier-header">
            <span></span>
            <div>{{ "SPACE.GUEST" | translate }}</div>
            <span></span>
          </ion-col>
        </ion-row>
        <ion-row class="margin-bottom-8">
            <ion-icon name="person-outline" class="margin-right-8"></ion-icon>
            {{ row.description }}
        </ion-row>
      </ng-container>
      
      <ion-row>
        <ion-col class="space-booking-view__mobile-dates-label">
          <span>
            {{ "SPACE.RESERVATION_START" | translate }}
          </span>
          <span>
            {{ "SPACE.RESERVATION_END" | translate }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          class="display-flex ion-align-items-center ion-justify-content-between"
        >
          <div
            class="space-booking-view__mobile-dot space-booking-view__mobile-dot--start"
          ></div>
          <div class="space-booking-view__mobile-separator"></div>
          <div
            class="space-booking-view__mobile-dot space-booking-view__mobile-dot--end"
          ></div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="space-booking-view__mobile-dates-container">
          <span>
            {{ row.startTime | dateSti }}
          </span>
          <span>
            {{ row.endTime | dateSti }}
          </span>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>